"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertAddressFromRecharge = exports.convertAddressToRecharge = exports.convertShopifyLineItemsToRecharge = void 0;
function convertShopifyLineItemsToRecharge(lineItems) {
    var lines = lineItems.map(function (shopifyLi) {
        var _a;
        var key = { weeks: 'week', days: 'day', months: 'month' };
        var rechargeLi = {
            variant_id: shopifyLi.variant_id,
            quantity: shopifyLi.quantity,
            line_price: (shopifyLi.line_price / 100).toFixed(2),
            price: (shopifyLi.price / 100).toFixed(2),
            grams: shopifyLi.grams,
            requires_shipping: shopifyLi.requires_shipping,
            sku: shopifyLi.sku,
            taxable: shopifyLi.taxable,
            product_id: shopifyLi.product_id,
            properties: [],
        };
        var clonedProperties = Object.assign({}, shopifyLi.properties);
        var shopifyShippingIntervalUnitType = clonedProperties.shipping_interval_unit_type;
        var shopifyChargeIntervalFrequency = clonedProperties.charge_interval_frequency;
        var orderIntervalFrequency = clonedProperties.shipping_interval_frequency;
        delete clonedProperties.shipping_interval_unit_type;
        delete clonedProperties.charge_interval_frequency;
        delete clonedProperties.shipping_interval_frequency;
        if (shopifyShippingIntervalUnitType)
            rechargeLi.order_interval_unit = key[shopifyShippingIntervalUnitType.toString().toLowerCase()] || 'week';
        if (shopifyChargeIntervalFrequency)
            rechargeLi.charge_interval_frequency = Number(shopifyChargeIntervalFrequency);
        if (orderIntervalFrequency)
            rechargeLi.order_interval_frequency = Number(orderIntervalFrequency);
        for (var pKey in clonedProperties) {
            if (clonedProperties.hasOwnProperty(pKey)) {
                var element = clonedProperties[pKey];
                (_a = rechargeLi.properties) === null || _a === void 0 ? void 0 : _a.push({ name: pKey, value: element.toString() });
            }
        }
        return rechargeLi;
    });
    return lines;
}
exports.convertShopifyLineItemsToRecharge = convertShopifyLineItemsToRecharge;
function convertAddressToRecharge(address) {
    return {
        first_name: address.firstName,
        last_name: address.lastName,
        address1: address.address1,
        address2: address.address2,
        city: address.city,
        province: address.state,
        country: address.country,
        zip: address.zip,
        company: address.company,
        phone: address.phoneNumber,
    };
}
exports.convertAddressToRecharge = convertAddressToRecharge;
function convertAddressFromRecharge(addr) {
    return {
        firstName: addr.first_name,
        lastName: addr.last_name,
        address1: addr.address1,
        address2: addr.address2,
        city: addr.city,
        state: addr.province,
        country: addr.country,
        zip: addr.zip,
        company: addr.company,
        phoneNumber: addr.phone,
    };
}
exports.convertAddressFromRecharge = convertAddressFromRecharge;
